import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, KeyRound, Search, ShieldCheck, Gift, Flame } from "lucide-react";

import { Show, UserButton } from "@clerk/react";
import { useCart } from "@/context/CartContext";
import { CartSheet } from "@/components/store/CartSheet";

const navCls = ({ isActive }) =>
  `hidden lg:inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md transition-colors ${isActive ? "text-white bg-white/5" : "text-gray-400 hover:text-white"}`;

export const Header = () => {
  const { count, setOpen } = useCart();
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#08090C]/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-3 sm:px-8 h-16 flex items-center gap-1 sm:gap-4">
        <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-2 mr-auto min-w-0">
          <span className="w-8 h-8 shrink-0 grid place-items-center rounded-md bg-emerald-500 text-[#08090C]"><KeyRound size={18} strokeWidth={2.5} /></span>
          <span className="font-display font-bold tracking-tight text-base sm:text-lg truncate">Game<span className="text-emerald-400">Realm</span></span>
        </Link>
        <NavLink to="/" end className={navCls} data-testid="nav-store-link"><Search size={15} /> Store</NavLink>
        <NavLink to="/offers" className={navCls} data-testid="nav-offers-link"><Flame size={15} className="text-amber-400" /> Offer of the week</NavLink>
        <NavLink to="/mystery" className={navCls} data-testid="nav-mystery-box-link"><Gift size={15} /> Mystery Box</NavLink>
        <NavLink to="/blog" className={navCls} data-testid="nav-blog-link">Blog</NavLink>
        <NavLink to="/order" className={navCls} data-testid="nav-order-lookup-link"><ShieldCheck size={15} /> Track order</NavLink>
        <NavLink to="/blog" data-testid="nav-blog-mobile" className="lg:hidden shrink-0 px-2 py-2.5 text-sm text-gray-400 hover:text-white">Blog</NavLink>
        <Show when="signed-in">
          <NavLink to="/admin" className={navCls} data-testid="nav-admin-link">Admin</NavLink>
          <NavLink to="/admin" data-testid="nav-admin-mobile" className="lg:hidden shrink-0 px-2 py-2 text-sm text-gray-400 hover:text-white">Admin</NavLink>
          <UserButton />
        </Show>
        <button
          data-testid="cart-open-button"
          onClick={() => setOpen(true)}
          className="relative shrink-0 hidden lg:inline-flex items-center gap-1.5 sm:gap-2 h-10 px-2.5 sm:px-4 rounded-md bg-emerald-500 text-[#08090C] font-semibold text-sm hover:bg-emerald-400 transition-colors"
        >
          <ShoppingBag size={16} /> <span className="hidden sm:inline">Cart</span>
          <span data-testid="cart-count-badge" className="font-mono text-xs bg-[#08090C] text-emerald-400 rounded px-1.5 py-0.5">{count}</span>
        </button>
      </div>
      <CartSheet />
    </header>
  );
};
